const LETTERBOX_ACCESS = new Map();
LETTERBOX_ACCESS.set('MODIFICATION', 'Modification');
LETTERBOX_ACCESS.set('READ', 'Lecture');

export default LETTERBOX_ACCESS;
